import { BreakpointObserver } from '@angular/cdk/layout';

import { DOCUMENT, Inject, Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { asapScheduler, Subject } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { SidebarItem } from '../sidebaritem';
import { LocalStorageService } from './storage.service';

@Injectable({
	providedIn: 'root',
})
export class SidenavService {
	public rightPanel: MatSidenav;
	private rightVCR: ViewContainerRef;
	public leftMenuData = new Subject<SidebarItem[]>();
	private tabletBreakpointWidth: number = 1024;
	private mobileBreakpointWidth: number = 960;
	private _isTablet: boolean;
	private _isPhone: boolean;
	private _isMobileMenuOpened: boolean;
	public bRightSidebarExpandedStatus: boolean = true;
	private _isRightPanelOpened: boolean;

	// Used from sidebar widgets
	public rightSidebarExpandedStatus = new Subject<boolean>();
	public rightSidebarExpandedStatus$ = this.rightSidebarExpandedStatus.asObservable();

	constructor(
		private breakpointObserver: BreakpointObserver,
		private authService: AuthService,
		private localStorageService: LocalStorageService,
		@Inject(DOCUMENT) private document: any,
	) {
		this.breakpointObserver.observe([`(max-width: ${this.tabletBreakpointWidth}px)`]).subscribe((res) => {
			this._isTablet = res.matches;
			this.bRightSidebarExpandedStatus = !res.matches;
			this.rightSidebarExpandedStatus.next(this.bRightSidebarExpandedStatus);
		});

		this.breakpointObserver.observe([`(max-width: ${this.mobileBreakpointWidth}px)`]).subscribe((res) => {
			this._isPhone = res.matches;
			this.bRightSidebarExpandedStatus = !res.matches;
			this.rightSidebarExpandedStatus.next(this.bRightSidebarExpandedStatus);
		});
	}

	setMenuData(menuData: SidebarItem[]) {
		this.leftMenuData.next(menuData);
	}

	getMenuData() {
		return this.leftMenuData.asObservable();
	}

	setPanel(sidenav: MatSidenav) {
		this.rightPanel = sidenav;
	}

	setContentVcf(viewContainerRef: ViewContainerRef) {
		this.rightVCR = viewContainerRef;
	}

	setRightPanelContent(content: TemplateRef<any>) {
		this.createView(content);
	}

	async openRightPanel(): Promise<any> {
		this._isRightPanelOpened = true;
		return this.rightPanel.open();
	}

	async openRightPanelWithContent(content: TemplateRef<any>): Promise<any> {
		this.createView(content);
		this._isRightPanelOpened = true;
		return this.rightPanel.open();
	}

	async closeRightPanel(): Promise<any> {
		// Will hide right sidebar completely
		this._isRightPanelOpened = false;
		return this.rightPanel.close();
	}

	toggleRightPanel() {
		if (this._isRightPanelOpened) {
			void this.closeRightPanel();
		} else {
			void this.openRightPanel();
		}
	}

	toggleRightPanelExpansion() {
		// Will collapse right sidebar to widget icon boxes
		this.bRightSidebarExpandedStatus = !this.bRightSidebarExpandedStatus;
		this.rightSidebarExpandedStatus.next(this.bRightSidebarExpandedStatus);
		this.localStorageService.set('User.Selected.SideNav.RightIsExpanded', this.bRightSidebarExpandedStatus);
	}

	setRightPanelExpansion(expand: boolean) {
		this.bRightSidebarExpandedStatus = expand;
		this.rightSidebarExpandedStatus.next(this.bRightSidebarExpandedStatus);
	}

	createView(template: TemplateRef<any>) {
		asapScheduler.schedule(() => {
			this.rightVCR.clear();
			this.rightVCR.createEmbeddedView(template);
		});
	}

	isTablet() {
		return this._isTablet;
	}

	isPhone() {
		return this._isPhone;
	}

	toggleMobileMenu() {
		this._isMobileMenuOpened = !this._isMobileMenuOpened;
	}

	isMobileMenuOpened() {
		return this._isMobileMenuOpened;
	}
}
